import { FeatureFlagsRaw, FeatureFlagsParsed } from './featureFlags.types';

type ParsedValue = boolean | number | string | object | unknown[];

function parseValue(value: string): ParsedValue {
    if (value === 'true') return true;
    if (value === 'false') return false;

    const num = Number(value);
    if (!Number.isNaN(num) && value.trim() !== '') return num;

    const trimmed = value.trim();
    if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
        try {
            return JSON.parse(value);
        } catch {
            return value;
        }
    }

    return value;
}

export function parseFeatureFlags(raw: FeatureFlagsRaw): FeatureFlagsParsed {
    const parsed: Record<string, ParsedValue> = {};

    for (const key in raw) {
        if (Object.prototype.hasOwnProperty.call(raw, key)) {
            parsed[key] = parseValue(raw[key]);
        }
    }

    return parsed as FeatureFlagsParsed;
}
